import slide11 from './assets/1-1.webp';
import slide12 from './assets/1-2.webp';
import slide13 from './assets/1-3.webp';
import slide14 from './assets/1-4.webp';
import slide21 from './assets/2-1.webp';
import slide22 from './assets/2-2.webp';
import slide23 from './assets/2-3.webp';
import slide24 from './assets/2-4.webp';
import slide31 from './assets/3-1.webp';
import slide32 from './assets/3-2.webp';
import slide33 from './assets/3-3.webp';
import slide34 from './assets/3-4.webp';
import slide41 from './assets/4-1.webp';
import slide42 from './assets/4-2.webp';

export const landscapingContent = {
  kicker: 'благоустройство',
  title: [
    { text: 'приватная территория:', accent: true },
    { text: '12 гектаров только', accent: false },
    { text: 'для своих', accent: false },
  ],
  subtitle: [
    { text: 'Мы превратили придомовую территорию', accent: true },
    { text: 'в продолжение ландшафта Камы', accent: false },
  ],
  cardTitle: [
    { text: 'внутреннее пространство ', accent: true },
    { text: 'спроектировано так, ', accent: true },
    { text: 'чтобы природа обнимала дом', accent: false },
  ],
  tabs: [
    {
      name: 'двор-парк',
      slides: [
        {
          image: slide11,
          subtitle: 'дендропарк у дома',
          text: [
            { text: 'высажены характерные для Прикамья растения: ', accent: true },
            { text: 'ивы, ольха, липы и клены, которые создают тень и фильтруют воздух.', accent: false },
          ],
        },
        {
          image: slide12,
          subtitle: 'умное зонирование',
          text: [
            { text: 'игровые площадки  разделены по возрастам (0–3, 3–6, 6+ лет), ', accent: true },
            { text: 'чтобы малыши и подростки не мешали друг другу', accent: false },
          ],
        },
        {
          image: slide13,
          subtitle: 'эко-покрытия',
          text: [
            { text: 'для безопасности и тактильного разнообразия ', accent: true },
            { text: 'используются резиновая крошка, песок, речная галька и мульча', accent: false },
          ],
        },
        {
          image: slide14,
          subtitle: 'работа на воздухе',
          text: [
            { text: 'навесы-паруса со столами и встроенными зарядками ', accent: true },
            { text: 'превращают двор в летний коворкинг', accent: false },
          ],
        },
      ],
    },
    {
      name: 'прогулочный бульвар',
      slides: [
        {
          image: slide21,
          text: [
            { 
              text: 'центральная ось квартала, превращающая путь домой в маленькое путешествие. ', accent: true
            },
            {
              text: 'это пространство спроектировано для неспешных променадов и добрососедского общения', accent: false
            },
          ],
        },
        {
          image: slide22,
          subtitle: 'атмосфера курорта',
          text: [
            { text: 'деревянные настилы и тени деревьев ', accent: true },
            { text: 'создают ощущение загородного отдыха', accent: false },
          ],
        },
        {
          image: slide23,
          subtitle: 'вечерняя магия',
          text: [
            { text: 'специальное освещение с гирляндами делает бульвар ', accent: true },
            { text: 'идеальным местом для тихих вечерних прогулок', accent: false },
          ],
        },
        {
          image: slide24,
          subtitle: 'зоны отдыха',
          text: [
            { text: 'вдоль маршрута расставлены скамейки,', accent: true },
            { text: 'где можно передохнуть или почитать книгу', accent: false },
          ],
        },
      ],
    },
    {
      name: 'собственная набережная',
      slides: [
        {
          image: slide31,
          subtitle: 'финальная точка маршрута',
          text: [
            { text: 'благоустроенный берег реки сразу за территорией комплекса. ', accent: true },
            { text: 'это ваше место силы для вдохновения, теплых встреч и созерцания воды', accent: false },
          ],
        },
        {
          image: slide32,
          subtitle: 'утренние ритуалы',
          text: [
            { text: 'начинайте день с заряжающей пробежки вдоль берега, ', accent: true },
            { text: 'неспешной прогулки с собакой или занятий йогой под тихий шум волн', accent: false },
          ],
        },
        {
          image: slide33,
          subtitle: 'место для перезагрузки',
          text: [
            { text: 'спускайтесь к реке, чтобы почитать книгу на свежем воздухе, ', accent: true },
            { text: 'выпить кофе или просто побыть в тишине после насыщенного рабочего дня', accent: false },
          ],
        },
        {
          image: slide34,
          subtitle: 'живописная панорама',
          text: [
            { text: 'бескрайние виды на воду и потрясающие закаты,  ', accent: true },
            { text: 'которые помогают отвлечься от городской суеты и замедлить ритм ', accent: false },
          ],
        },
      ],
    },
    {
      name: 'спортивное пространство для всех',
      slides: [
        {
          image: slide41,
          text: [
            { text: 'инфраструктура двора учитывает интересы не только детей, ', accent: true },
            { text: 'но и взрослых, поддерживая здоровый образ жизни', accent: false },
          ],
        },
        {
          image: slide42,
          subtitle: 'воркаут-зоны',
          text: [
            { text: 'уличные тренажеры и площадки для баскетбола ', accent: true },
            { text: 'или футбола с профессиональным покрытием', accent: false },
          ],
        },
      ],
    },
  ],
};